import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import Navigation from './components/Navigation'
import Footer from './components/Footer'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import Home from './Pages/Home'
import About from './Pages/About'
import Contacts from './Pages/Contacts'
import Services from './Pages/Services'
import Advertisements from './Pages/services/Advertisements'
import Webdesigning from './Pages/services/Webdesigning'
import StaffOwnerTraning from './Pages/services/StaffOwnerTraning'
import SocialMediaOptimization from './Pages/services/SocialMediaOptimization'
import StrategicPlanning from './Pages/services/StrategicPlanning'
import SEO from './Pages/services/SEO'
import SEM  from './Pages/services/SEM'
import PrintMedia from './Pages/services/PrintMedia'
import GoogleAdwords from './Pages/services/GoogleAdwords'
import Events from './Pages/services/Events'
import DigitalMarketing from './Pages/services/DigitalMarketing'
import Branding from './Pages/services/Branding'
import Choose from './Pages/Choose'
import Testimonials from './Pages/Testimonials'
import Navigation_1 from './components/Navigation_1'
import Whatsup from './components/Whatsup'
import Home_New from './Pages/Home_New'

export default function App() {
  return <>
  <BrowserRouter>
  {/* <Navigation/> */}

  <Navigation_1/>
  <Routes>
    {/* <Route path="/" element={<Home/>}></Route> */}
    <Route path="/" element={<Home_New/>}></Route>
    <Route path="/about" element={<About/>}></Route>
    <Route path="/contacts" element={<Contacts/>}></Route>
    <Route path="/services" element={<Services/>}></Route>
    <Route path="/choose" element={<Choose/>}></Route>
    <Route path="/testimonials" element={<Testimonials/>}></Route>

    {/* services */}
    <Route path="/advertisements" element={<Advertisements/>}></Route>
    <Route path="/webdesigning" element={<Webdesigning/>}></Route>
    <Route path="/strategicplanning" element={<StrategicPlanning/>}></Route>
    <Route path="/staffownertraining" element={<StaffOwnerTraning/>}></Route>
    <Route path="/socialmediaoptimization" element={<SocialMediaOptimization/>}></Route>
    <Route path="/seo" element={<SEO/>}></Route>
    <Route path="/sem" element={<SEM/>}></Route>
    <Route path="/printmedia" element={<PrintMedia/>}></Route>
    <Route path="/googleadwords" element={<GoogleAdwords/>}></Route>
    <Route path="/events" element={<Events/>}></Route>
    <Route path="/digitalmarketing" element={<DigitalMarketing/>}></Route>
    <Route path="/branding" element={<Branding/>}></Route>

  </Routes>
  <Footer/>
  <Whatsup/>
  </BrowserRouter>


  
  
  </>
}
